import {
  Component,
  EventEmitter,
  Output,
  Input,
  ElementRef,
  AfterContentChecked,
} from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { EventData, SelectItem } from '../../types';

@Component({
  selector: 'app-select-item',
  templateUrl: './select-item.component.html',
  styleUrls: ['./select-item.component.scss'],
  standalone: true,
  imports: [IonicModule],
})
export class SelectItemComponent<T>
  implements SelectItem<T>, AfterContentChecked
{
  @Input({ required: true }) value: string;
  @Input() label = this.el.nativeElement.innerText as string;
  @Input() item?: T;

  @Output() clickEvent = new EventEmitter<EventData<T>>();

  constructor(private el: ElementRef) {}

  onClick() {
    this.clickEvent.emit({
      value: this.value,
      label: this.label,
      item: this.item,
    });
  }

  ngAfterContentChecked() {
    this.label = this.label || this.el.nativeElement.innerText;
  }
}
